import React from 'react';
import './Main.styles.scss';
import { IoMdPin } from 'react-icons/io';
import { FaMobileAlt } from 'react-icons/fa';
import { MdOutlineStar } from 'react-icons/md';
import vars from '../vars.scss';
import googleIcon from '../images/google-icon-2.webp';
import Carousel from './Carousel';

export function Main() {
  return (
    <article className="main-article">
      <h3 className="main-content-header main-content-header-about">
        <span>O kancelarii</span>
      </h3>
      <div className="main-content-text">
        <p>
          Kancelaria świadczy <b>kompleksową pomoc prawną</b> dostosowaną
          do&nbsp;indywidualnych potrzeb klientów. Oferuję fachowe konsultacje,
          rzetelne opinie prawne oraz reprezentację przed sądami, dbając
          o&nbsp;pomyślne rozstrzygnięcie każdej sprawy.
        </p>
        <p>
          Dzięki&nbsp;
          <b>wieloletniemu doświadczeniu i&nbsp;wysokim kwalifikacjom</b>,
          zapewniam profesjonalizm i&nbsp;skuteczność. Wiedza prawnicza
          to&nbsp;podstawa, ale równie ważne jest&nbsp;
          <b>zaangażowanie</b>,<b> empatia i&nbsp;kreatywność</b> w&nbsp;
          podejściu do&nbsp;każdej sprawy. Dlatego zawsze poświęcam czas
          na&nbsp;dokładne omówienie sytuacji i&nbsp;wyczerpujące odpowiedzi
          na&nbsp;pytania klientów.
        </p>
        <p>
          <b>Zakres działania</b>
        </p>
        <p>
          <IoMdPin
            style={{
              marginRight: '5px',
              fontSize: '30px',
              verticalAlign: 'middle',
            }}
          />
          Lokalnie – Wrocław, Jastrzębie-Zdrój i okolice.
        </p>
        <p>
          <FaMobileAlt
            style={{
              marginRight: '5px',
              fontSize: '30px',
              verticalAlign: 'middle',
            }}
          />
          Zdalnie – na terenie całej Polski i&nbsp;dla klientów zagranicznych (w
          języku polskim i&nbsp;angielskim).
        </p>
        <p>
          Nowoczesne technologie umożliwiają mi&nbsp;skuteczne prowadzenie spraw
          na&nbsp;odległość, dzięki czemu mogę pomagać klientom niezależnie
          od&nbsp;ich lokalizacji.
        </p>
        <p>
          <b>Zapraszam do kontaktu</b>
        </p>
        <p>r.pr. Magdalena Pawlak</p>
      </div>
      <Carousel items={googleOpinions} visibleItems={3} />
    </article>
  );
}

const createGoogleReviewComponent = (review, author, timeAgoInPolish) => {
  return (
    <>
      <div className="google-review">
        <div className={'bold-line'}></div>
        <div className={'content'}>
          <div className={'grade-and-time'}>
            <div className={'grade'}>
              <div className={'google-icon'}>
                <img src={googleIcon} alt={'google-icon'} />
              </div>
              <div className={'rate'}>
                <MdOutlineStar color={vars.baseColor} />
                <MdOutlineStar color={vars.baseColor} />
                <MdOutlineStar color={vars.baseColor} />
                <MdOutlineStar color={vars.baseColor} />
                <MdOutlineStar color={vars.baseColor} />
              </div>
            </div>
            <div className={'time-ago'}>{timeAgoInPolish} temu</div>
          </div>
          <div className={'review-text'}>"{review.trim()}"</div>
          <div className={'review-author'}>{author.trim()}</div>
        </div>
      </div>
    </>
  );
};

const googleOpinions = [
  {
    content: createGoogleReviewComponent(
      `
        Rewelacja. Sprawa poszła dokładnie tak, jak Pani Mecenas zaplanowała. 
        Byłem w szoku. Poza tym wszystko na max: życzliwość, terminowość, słowność. 
        W dzisiejszych czasach to niestety rzadkość.
        `,
      'Krzysztof Stencel',
      timeAgoInPolishCalc(new Date(2025, 3, 1))
    ),
  },
  {
    content: createGoogleReviewComponent(
      `
        Współpracuję z Mecenas Pawlak jako radca prawny świadcząc usługi prawne
        dla klientów indywidualnych i biznesowych. Mecenas Pawlak jest rzetelnym
        pełnomocnikiem z indywidualnym podejściem do klienta. Mecenas Pawlak
        pozostaje z klientem w kontakcie do prawomocnego zakończenia sprawy
        informując na bieżąco z kolejnych krokach podejmowanych w sprawie i
        ustalając dalsze działania z klientem. Polecam serdecznie usługi Mecenas
        Pawlak.
        `,
      'Marta Poźniak',
      timeAgoInPolishCalc(new Date(2025, 1, 1))
    ),
  },
  {
    content: createGoogleReviewComponent(
      `
      Jestem bardzo  zadowolona z Pani Magdaleny Pawlak bardzo mi pomogła jak i dała wsparcia podczas mojej sprawy
Szczególnie że to była moja pierwsza sprawa w życiu i to w wieku 17 lat
Polecam bardzo Panią Magdalenę🙂... 
        `,
      'Monika Gołek',
      timeAgoInPolishCalc(new Date(2024, 9, 1))
    ),
  },
  {
    content: createGoogleReviewComponent(
      `
      Bardzo profesjonalna, rzeczowa, szybka i przede wszystkim skuteczna usługa. 
      Pani adwokat wykazala się nie tylko wiedzą i zaangazowaniem, 
      ale rozwniez empatią. Bardzo wzorowa i godna pochwały postawa
        `,
      'Michał Maleska',
      timeAgoInPolishCalc(new Date(2024, 9, 1))
    ),
  },
  {
    content: createGoogleReviewComponent(
      `
      Kancelaria radcy prawnej Pani Magdaleny Pawlak cechuje się doskonałym kontaktem z klientem. 
      Pani Magda jest zawsze dostępna, gotowa odpowiedzieć na wszelkie pytania i rozwiać wątpliwości. 
      Jej zaangażowanie i pełen profesjonalizm sprawiają, że współpraca z nią to czysta przyjemność.
        `,
      'Piotr Mitka',
      timeAgoInPolishCalc(new Date(2024, 5, 1))
    ),
  },
  {
    content: createGoogleReviewComponent(
      `
      Profesjonalne podejście, ciągły kontakt z Panią Magdaleną, pieniążki z ZUSu odzyskane
Polecam
        `,
      'Agata Stankiewicz',
      timeAgoInPolishCalc(new Date(2024, 5, 1))
    ),
  },
  {
    content: createGoogleReviewComponent(
      `
      Zostałem bardzo zadowolony ze współpracy z Panią Magdaleną.
Sprawa została szybko i skutecznie załatwiona w sądzie.
Bardzo polecam.
        `,
      'Andrii Poliezhai',
      timeAgoInPolishCalc(new Date(2024, 11, 1))
    ),
  },
];

function timeAgoInPolishCalc(date) {
  const now = new Date();
  const diffInMilliseconds = now - date;
  const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

  const months = Math.floor(diffInDays / 30);
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  if (months <= 11) {
    if (months === 0) {
      return `${diffInDays} dni`;
    }
    return `${months} ${getMonthLabel(months)}`;
  } else {
    if (remainingMonths === 0) {
      return `${years} ${getYearLabel(years)}`;
    } else {
      return `${years} ${getYearLabel(years)} i ${remainingMonths} ${getMonthLabel(remainingMonths)}`;
    }
  }
}

function getMonthLabel(months) {
  if (months === 1) return 'miesiąc';
  if (months >= 2 && months <= 4) return 'miesiące';
  return 'miesięcy';
}

function getYearLabel(years) {
  return years === 1 ? 'rok' : 'lata';
}
